import * as React from 'react';

interface Props {
    /**
     * Si es `true` la description se muestra en rojo, si es `false` en gris.
     */
    error?: boolean;

    /** Contenido de la descripción. Incompatible con *children*. */
    content?: string;

    /** Contenido de la descripción. Incompatible con *content*. */
    children?: React.ReactNode;
}

const Field: React.FunctionComponent<Props> = props => {
    const { error, content, children } = props;
    return (
        <p style={{ fontSize: '90%', marginTop: '6px', color: error ? '#9f3a38' : '#555' }}>
            {content || children}
        </p>
    );
};

export default Field;



// WEBPACK FOOTER //
// ./src/componentes/semantic-ui-extended/Description/index.tsx